<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />

    <v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      style="max-width: 165px;"
      v-model="searchText"
      v-on:keyup.enter="doSearch"
    >
      <template
        v-if="$vuetify.breakpoint.mdAndUp"
        v-slot:append-outer
      >
        <v-btn
          class="mt-n2"
          elevation="1"
          fab
          small
          @click="doSearch()"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>

    <div class="mx-3" />

    <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/"
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>
    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <div class="user">{{ user.name }}</div>
        <v-divider />
        <app-bar-item @click="logOut">
            <div
              @click="logOut"
              class="menuEntry"
            >
              <v-icon>mdi-logout</v-icon> Log out
            </div>
        </app-bar-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'
  import UserService from '@/services/user'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      profile: [
        { title: 'Log out' },
      ],
      searchText: undefined,
    }),

    computed: {
      ...mapState(['drawer']),
      ...mapState({
        user (state) {
          return state.user.data
        },
      }),
    },
    watch: {
      $route (to, from) {
        this.updateSearchText()
      },
    },
    mounted () {
      this.updateSearchText()
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      logOut () {
        const us = new UserService()
        us.logOut().finally(() => {
          this.$router.push('/login')
        })
      },
      updateSearchText () {
        this.searchText = this.$route.query.q
      },
      doSearch () {
        this.$router.push({ path: '/search', query: { q: this.searchText } })
      },
    },
  }
</script>

<style>
  .user {
    text-align: center;
    font-weight: bold;
    padding: 5px 2px 5px 2px;
  }
  .v-menu__content .v-list--nav .v-list-item {
    padding: 0px;
  }
  .menuEntry {
    padding: 5px;
    width: 100%;
  }
</style>
